export { default } from './TableContainer';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/TableContainer/index.js
// module id = 361
// module chunks = 0